<template>
    <div v-if="messages.length" class="alert alert-danger form-api-errors" role="alert">
        <div v-for="(message, index) in messages" :key="index">{{ message }}</div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

// API errors whose key is not one of the form's fields (they would otherwise be silent); on a list, every API error
export default {
    props: {
        fields: {
            type: Array,
            default: () => [],
        },
        // the form's own label for an API key that is not one of its fields (e.g. { Tabs: $t('tabs') })
        labels: {
            type: Object,
            default: () => ({}),
        },
        // lists have no alert() for plain-text errors: show those too
        showText: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            // errors raised before this form was shown belong to another form
            since: this.$store.state.alert.seq,
        };
    },
    computed: {
        ...mapState({
            alertSeq: state => state.alert.seq,
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        messages: function()
        {
            if(this.alertType != 'alert-danger' || !this.alertOutput || this.alertSeq <= this.since) return [];
            if(!Array.isArray(this.alertOutput)) return this.showText && typeof this.alertOutput === 'string' ? [this.alertOutput] : [];

            // say what the message is about: the form's label for the key, else the key itself (not when the
            // message already starts with its path, nor for an unreadable body, whose message says it all)
            return this.alertOutput.filter(error => !this.fields.includes(error.key)).map(error =>
                error.key === '_request' || String(error.value).startsWith(error.key) ? error.value : `${this.labels[error.key] || error.key}: ${error.value}`);
        }
    }
}
</script>
